import { BaseEntity, Default, Transform, toEntity } from './base';
import { NoteModel } from './note';
import { UserAddressModel } from './user-address';
export class UserModel extends BaseEntity {
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  inviteCode?: string;
  points: number;
  vip: boolean;
  firstTimeCustomer: boolean;
  fleet: boolean;

  @Default(false)
  admin: boolean;

  @Default(false)
  filler: boolean;

  @Default(false)
  provider: boolean;

  @Transform(toEntity(NoteModel))
  notes?: NoteModel[];

  // Todo: Remove as soon as ops API permits
  @Transform(toEntity(UserAddressModel))
  userAddresses: UserAddressModel[];
}

export interface UserParams {
  firstName?: string;
  lastName?: string;
  signupSource?: string;
  locationName?: string;
  locationDescription?: string;
  lat?: number;
  lng?: number;
  zipCode?: string;
  phone?: string;
  email?: string;
}

export interface UserUpdateParams {
  ref?: string;
  deepLinkData?: any;
  firstName?: string;
  lastName?: string;
  email?: string;
  phone?: string;
  gmAuthCode?: string;
}



// WEBPACK FOOTER //
// ./src/models/user.ts